import { Input } from '@/cn/ui/input'
import { ArrowLeft } from 'lucide-react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import PeopleSearch from './people_search_component'

const SearchBar = () => {
  const [q, setQ] = useState('')
  const navigate = useNavigate()
  return (
    <div className="flex flex-col bg-background text-foreground h-full rounded-none px-4 py-2 w-full">
      <Input
        onChange={(e) => setQ(e.target.value)}
        value={q}
        icon={<ArrowLeft onClick={() => navigate(-1)} className="cursor-pointer" />}
        className="rounded-full bg-[#D9D9D91A]"
        placeholder="Pay anyone by Cray ID or name"
      />
      <div className="mt-3" />
      <PeopleSearch query={q} onSelect={(c) => navigate('/dashboard/send-money', { state: c })} showRecents />
    </div>
  )
}

export default SearchBar
